<div *ngIf="riskQuestions.investmentHorizon.length">
  <div class="flex-row flex-justify-center strategy-header" *ngIf="!recheck">
    <div class="flex-col-4 flex-col-md-6 flex-col-sm-12">
      <h1 class="ui-headline">
        <ng-container *ngIf="currentAccount.step_status === 1; else riskNameTitle">
          {{ 'new_strategy.risk_screen.h2' | translate }}
        </ng-container>
        <ng-template #riskNameTitle>
          {{ 'new_strategy.risk_screen.slider.active.' + riskName | translate }} {{ 'new_strategy.risk_screen.h4-2' | translate }}
        </ng-template>
      </h1>
      <p>{{ 'new_strategy.risk_screen.subtitle' | translate }}</p>
    </div>
  </div>
  <!-- RISK CATEGORIES -->
  <div class="flex-row flex-justify-center">
    <div class="flex-col-4 flex-col-md-6 flex-col-sm-12">
      <!-- INVESTMENT HORIZON -->
      <div
        class="risk-questions-category"
        [ngClass]="{
          collapsed: categories.investmentHorizon.collapsed,
          disabled: categories.investmentHorizon.disabled
        }"
      >
        <div class="risk-questions-category-title" (click)="toggleCategory('investmentHorizon')">
          <span>{{ 'new_strategy.risk_screen.3a.sectionTitle.investmentHorizon' | translate }}</span>
          <span class="icon-i-chevron-down"></span>
        </div>
        <div
          data-cy="div-horizon"
          class="questions-holder"
          [ngClass]="{
            expand: !categories.investmentHorizon.collapsed || recheck
          }"
        >
          <div class="risk-question too-long" *ngFor="let question of riskQuestions.investmentHorizon">
            <div
              class="risk-question-title"
              (click)="question.inyova_id === RISK_CONSTANTS.INVESTMENT_HORIZON_FIRST_QUESTION_ID ? (question.hasAnswer = !question.hasAnswer) : null"
            >
              <span [innerHTML]="question.question_text"></span>
              <app-ui-tooltip
                *ngIf="question.hint"
                [content]="question.hint"
                color="yellow"
                size="small"
                (mouseenter)="trackTooltip(question.question_text)"
              ></app-ui-tooltip>
            </div>
            <div
              class="risk-question-content"
              *ngIf="question.inyova_id === RISK_CONSTANTS.INVESTMENT_HORIZON_FIRST_QUESTION_ID; else yearsQuesetion"
            >
              <app-date-of-birth [savedDOB]="savedDOB" [invalidDate]="invalidDate" (changedDOB)="updateDOB($event)"></app-date-of-birth>
              <p class="date-error" *ngIf="invalidDate?.length">
                <span class="icon-i-close-circle"></span>
                <span>{{ invalidDate }}</span>
              </p>
            </div>
            <ng-template #yearsQuesetion>
              <div class="risk-question-content slider slider-box">
                <div class="range-unfilled"></div>
                <div class="range-filled" [ngStyle]="{ width: sliderValue }"></div>
                <input
                  #yearsSlider
                  class="form-slider"
                  type="range"
                  [value]="question?.survey_customer_answer?.answer"
                  [max]="maxSliderValue ? maxSliderValue : 0"
                  [min]="1"
                  [step]="1"
                  (change)="updateInvestmentHorizon($event, question)"
                  (input)="getSliderValue(yearsSlider.value)"
                />
              </div>
              <p class="additional-info">
                <span *ngIf="question?.survey_customer_answer?.answer && !this.invalidDate?.length">
                  {{
                    'new_strategy.risk_screen.3a.investmentHorizon.question1.retirmentCalculation'
                      | translate: { retirementAge: getRetirmentAge(question) }
                  }}
                </span>
              </p>
              <div class="withdrawal-section">
                <div class="withdrawal-section-separator"></div>
                <div class="withdrawal-section-title" (click)="withdrawalInfoOpen = !withdrawalInfoOpen">
                  <span>{{ 'new_strategy.risk_screen.3a.investmentHorizon.withdrawal.title' | translate }}</span>
                  <p>{{ withdrawalInfoOpen ? '-' : '+' }}</p>
                </div>
                <div class="withdrawal-section-content" *ngIf="withdrawalInfoOpen">
                  <p>{{ 'new_strategy.risk_screen.3a.investmentHorizon.withdrawal.p1' | translate }}</p>
                  <ul>
                    <li>• {{ 'new_strategy.risk_screen.3a.investmentHorizon.withdrawal.li1' | translate }}</li>
                    <li>• {{ 'new_strategy.risk_screen.3a.investmentHorizon.withdrawal.li2' | translate }}</li>
                    <li>• {{ 'new_strategy.risk_screen.3a.investmentHorizon.withdrawal.li3' | translate }}</li>
                  </ul>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      <!-- EXPENSES -->
      <div
        class="risk-questions-category"
        [ngClass]="{
          collapsed: categories.expenses.collapsed,
          disabled: categories.expenses.disabled
        }"
      >
        <div class="risk-questions-category-title" (click)="toggleCategory('expenses')">
          <span>{{ 'new_strategy.risk_screen.3a.expenses.sectionTitle' | translate }}</span>
          <span class="icon-i-chevron-down"></span>
        </div>
        <div
          data-cy="div-expenses"
          class="questions-holder"
          [ngClass]="{
            expand: !categories.expenses.collapsed || recheck
          }"
        >
          <div
            class="risk-question too-long"
            *ngFor="let question of riskQuestions.expenses; let i = index"
            [attr.data-cy]="'expenses-question-' + i"
          >
            <div class="risk-question-title" (click)="question.hasAnswer = !question.hasAnswer">
              <span [innerHTML]="question.question_text"></span>
              <app-ui-tooltip
                *ngIf="question.hint"
                [content]="question.hint"
                color="yellow"
                size="small"
                (mouseenter)="trackTooltip(question.question_text)"
              ></app-ui-tooltip>
            </div>
            <div class="flex-row" [class.hidden]="question.hasAnswer && !recheck">
              <ng-container *ngFor="let riskOption of question.survey_answer_options; let i = index">
                <div
                  class="snippet"
                  [ngClass]="{
                    active: riskOption.id === question.survey_customer_answer?.answer,
                    original: recheck && savedRiskAnswers.includes(riskOption.id)
                  }"
                  (click)="answerQuestion(question, riskOption, 'expenses')"
                >
                  {{ riskOption.option_text }}
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <!-- INCOME -->
      <div
        class="risk-questions-category"
        [ngClass]="{
          collapsed: categories.income.collapsed,
          disabled: categories.income.disabled
        }"
      >
        <div class="risk-questions-category-title" (click)="toggleCategory('income')">
          <span>{{ 'new_strategy.risk_screen.3a.income.sectionTitle' | translate }}</span>
          <span class="icon-i-chevron-down"></span>
        </div>
        <div
          class="questions-holder"
          data-cy="div-income"
          [ngClass]="{
            expand: !categories.income.collapsed || recheck
          }"
        >
          <div class="risk-question too-long" *ngFor="let question of riskQuestions.income; let i = index" [attr.data-cy]="'income-question-' + i">
            <div class="risk-question-title" (click)="question.hasAnswer = !question.hasAnswer">
              <span [innerHTML]="question.question_text"></span>
              <app-ui-tooltip
                *ngIf="question.hint"
                [content]="question.hint"
                color="yellow"
                size="small"
                (mouseenter)="trackTooltip(question.question_text)"
              ></app-ui-tooltip>
            </div>
            <div class="flex-row" [class.hidden]="question.hasAnswer && !recheck">
              <ng-container *ngFor="let riskOption of question.survey_answer_options; let i = index">
                <div
                  class="snippet"
                  [ngClass]="{
                    active: riskOption.id === question.survey_customer_answer?.answer,
                    original: recheck && savedRiskAnswers.includes(riskOption.id)
                  }"
                  (click)="answerQuestion(question, riskOption, 'income')"
                >
                  {{ riskOption.option_text }}
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <!-- RISK TAKING -->
      <div
        class="risk-questions-category"
        [ngClass]="{
          collapsed: categories.riskTaking.collapsed,
          disabled: categories.riskTaking.disabled
        }"
      >
        <div class="risk-questions-category-title" (click)="toggleCategory('riskTaking')">
          <span>{{ 'new_strategy.risk_screen.3a.riskTaking.sectionTitle' | translate }}</span>
          <span class="icon-i-chevron-down"></span>
        </div>
        <div
          class="questions-holder"
          data-cy="div-risk"
          [ngClass]="{
            expand: !categories.riskTaking.collapsed || recheck
          }"
        >
          <div class="risk-question too-long" *ngFor="let question of riskQuestions.riskTaking; let i = index" [attr.data-cy]="'risk-question-' + i">
            <div class="risk-question-title" (click)="question.hasAnswer = !question.hasAnswer">
              <span [innerHTML]="question.question_text"></span>
              <app-ui-tooltip
                *ngIf="question.hint"
                [content]="question.hint"
                color="yellow"
                size="small"
                (mouseenter)="trackTooltip(question.question_text)"
              ></app-ui-tooltip>
            </div>
            <div class="flex-row" [class.hidden]="question.hasAnswer && !recheck">
              <ng-container *ngFor="let riskOption of question.survey_answer_options; let i = index">
                <div
                  class="snippet"
                  [ngClass]="{
                    active: riskOption.id === question.survey_customer_answer?.answer,
                    original: recheck && savedRiskAnswers.includes(riskOption.id)
                  }"
                  (click)="answerQuestion(question, riskOption, 'riskTaking')"
                >
                  {{ riskOption.option_text }}
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <!-- WILLINGNESS -->
      <div *ngIf="!categories.willingness.disabled">
        <div
          class="checkbox-confirm"
          (click)="trustQuestion = !trustQuestion; enableSaveButtonCheck()"
          [ngClass]="{ alert: !enableSaveButton && !trustQuestion }"
        >
          <div class="checkbox-legal">
            <span [ngClass]="trustQuestion ? 'icon-i-checkbox-on' : 'icon-i-checkbox-off'"></span>
          </div>
          <p>{{ 'new_strategy.risk_screen.3a.regulatoryCheckbox' | translate }}</p>
        </div>
        <div #sliderWrapper class="slider-wrapper" data-cy="risk-slider">
          <p>{{ 'new_strategy.risk_screen.p' | translate }}</p>
          <app-strategy-stock-split-slider
            [bondRatio]="bondRatio"
            [customer]="customer"
            [insufficient]="insufficient"
            [maxSliderValue]="5"
            [minSliderValue]="minSliderValue"
            [pickedValue]="pickedValue"
            [recommendedClass]="recommendedClass"
            [riskName]="riskName"
            [stockRatio]="stockRatio"
            (update)="updateWillingnessQuestion($event)"
            [recheck]="recheck"
          ></app-strategy-stock-split-slider>
        </div>
        <div class="increased-risk" *ngIf="insufficient">
          <div class="increased-risk-top">
            <span class="icon-i-close-circle"></span>
            <p>{{ 'new_strategy.risk_screen.3a.higherRisk.message' | translate }}</p>
          </div>
        </div>
        <div class="slider-only-bonds" *ngIf="stockSplitPicked === 0">
          <span class="icon-i-close-circle"></span>
          <p>{{ 'new_strategy.risk_screen.3a.lowRiskError' | translate }}</p>
        </div>
        <p class="legal-notice">{{ 'new_strategy.risk_screen.3a.legalNotice' | translate }}</p>
      </div>
    </div>
  </div>
  <app-footer>
    <ng-container *ngIf="!recheck; else showRecheck">
      <ng-container *ngIf="currentAccount.step_status < 5; else otherSteps">
        <button (click)="send()" class="ui-button" [class.loading]="isLoading" [disabled]="!enableSaveButton">
          <span class="icon-i-windmill"></span>
          {{ 'new_strategy.investment_screen.cta' | translate }}
        </button>
      </ng-container>
      <ng-template #otherSteps>
        <button (click)="continue()" class="ui-button" [class.loading]="isLoading" [disabled]="!enableSaveButton">
          <span class="icon-i-windmill"></span>
          {{ 'new_strategy.investment_screen.cta' | translate }}
        </button>
      </ng-template>
    </ng-container>
    <ng-template #showRecheck>
      <button (click)="discard()" class="ui-button secondary">
        <span>{{ 'new_strategy.notifications.risk_recheck.discard' | translate }}</span>
      </button>
      <button (click)="sendRecheck()" class="ui-button" [class.loading]="isLoading" [disabled]="isLoading">
        <span class="icon-i-windmill"></span>
        {{ 'new_strategy.notifications.risk_recheck.save' | translate }}
      </button>
    </ng-template>
  </app-footer>
</div>
